<template>
    <div>
       <div class="d-flex justify-content-between align-items-center mb-1">
         <h5 class="mb-0">Mantenimientos - Tareas</h5>
         <div class="d-flex align-items-center">
           <b-button v-if="selectedRecords.length" class="btn-danger mr-1" @click="deleteSelectedRecords">
             <feather-icon
                 icon="TrashIcon"
                 size="16"
                 variant="primary"
                 class="cursor-pointer mr-1"
             />
             {{ selectedRecords.length === 1 ? "Borrar la tarea seleccionada" : `Borrar las ${selectedRecords.length} tareas seleccionadas` }}
           </b-button>
           <b-button size="sm" variant="outline-primary" @click="showFilters = !showFilters">
             <feather-icon icon="FilterIcon" size="14" class="mr-50"/>
             Filtros<span v-if="activeFilterCount"> ({{ activeFilterCount }})</span>
           </b-button>
         </div>
       </div>

       <b-collapse v-model="showFilters" class="mb-1">
         <b-card border-variant="light" class="mb-0 shadow-none border" body-class="p-1">
           <b-row>
             <b-col cols="12" md="6" lg="3" class="mb-1 mb-lg-0">
               <label class="small mb-25">Periodicidad</label>
               <b-form-select v-model="filters.periodicity" :options="periodicityFilterOptions" size="sm"/>
             </b-col>
             <b-col cols="12" md="6" lg="3" class="mb-1 mb-lg-0">
               <label class="small mb-25">Tarea</label>
               <b-form-select v-model="filters.document_type_id" :options="taskFilterOptions" size="sm"/>
             </b-col>
             <b-col cols="12" md="6" lg="3" class="mb-1 mb-lg-0">
               <label class="small mb-25">Fecha límite</label>
               <div class="d-flex">
                 <flat-pickr v-model="filters.expected_from" class="form-control form-control-sm" placeholder="Desde" :config="dateFilterConfig"/>
                 <flat-pickr v-model="filters.expected_to" class="form-control form-control-sm ml-25" placeholder="Hasta" :config="dateFilterConfig"/>
               </div>
             </b-col>
             <b-col cols="12" md="6" lg="3" class="mb-1 mb-lg-0">
               <label class="small mb-25">Fecha realización</label>
               <div class="d-flex">
                 <flat-pickr v-model="filters.effective_from" class="form-control form-control-sm" placeholder="Desde" :config="dateFilterConfig"/>
                 <flat-pickr v-model="filters.effective_to" class="form-control form-control-sm ml-25" placeholder="Hasta" :config="dateFilterConfig"/>
               </div>
             </b-col>
           </b-row>
           <div class="d-flex justify-content-end mt-1">
             <b-button size="sm" variant="outline-secondary" :disabled="!activeFilterCount" @click="clearFilters">
               Limpiar filtros
             </b-button>
           </div>
         </b-card>
       </b-collapse>
        <b-table
            class="maintenance-tasks-table"
            :items="displayedItems"
            :fields="documentsColumns"
            responsive
            sticky-header="500px"
            striped
            primary-key="id"
            show-empty
            editable
            :empty-text="hasActiveFilters ? 'No hay tareas que coincidan con los filtros' : 'No hay registros'"
            :selectable="this.editedRow === null"
            selected-variant="danger"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            no-local-sorting
            @row-selected="onRecordSelected"
        >
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>

            <template #cell(select_maintenance)="{ item }">
                <template>
                    <b-form-group class="form-check form-check-inline d-flex justify-content-center" @click.stop>
                        <b-form-radio v-model="item.select_maintenance" :checked="item.id === document_maintenance_active" name="select-maintenance" @change="setActiveMaintenance(item)" />
                    </b-form-group>
                </template>
            </template>

            <template #cell(expected_date)="{ item }">
                <template v-if="isRowEditable(item)">
                    <flat-pickr
                        v-model="item.expected_date"
                        class="form-control width-115"
                        name="expected_date"
                        autocomplete="off"
                        :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                    />
                </template>
                <template v-else>
                     <span class="text-nowrap">
                           {{ item.expected_date }}
                     </span>
                </template>
            </template>

            <template #cell(report_review_date)="{ item }">
                <template v-if="isRowEditable(item)">
                    <flat-pickr
                        v-model="item.report_review_date"
                        class="form-control width-115"
                        name="expected_date"
                        autocomplete="off"
                        :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                    />
                </template>
                <template v-else>
                       <span class="text-nowrap">
                             {{ item.report_review_date }}
                     </span>
                </template>
            </template>

            <template #cell(effective_date)="{ item }">
                <div :style="{ backgroundColor: item.inspection ? 'rgba(0, 128, 0, 0.2)' : (item.has_documents ? 'rgba(0, 167, 225, 0.2)' : '') }">
                    <template v-if="isRowEditable(item)">
                        <flat-pickr
                            v-model="item.effective_date"
                            class="form-control width-115"
                            name="effective_date"
                            autocomplete="off"
                            :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y'}"
                        />
                    </template>
                    <template v-else>
                        <span class="text-nowrap">
                             {{ item.effective_date }}
                     </span>
                    </template>
                </div>
            </template>

            <template #cell(periodicity)="{ item }">
                <template>
                    {{
                        maintenancePeriods.find(element => element.value == item.periodicity) ? maintenancePeriods.find(element => element.value == item.periodicity).name : ''
                    }}
                </template>
            </template>

            <template #cell(operator_nif_1)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-input v-model="item.operator_nif_1" autocomplete="off"/>
                </template>
                <template v-else>
                    {{ item.operator_nif_1 }}
                </template>
            </template>

            <template #cell(operator_nif_2)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-input v-model="item.operator_nif_2" autocomplete="off"/>
                </template>
                <template v-else>
                    {{ item.operator_nif_2 }}
                </template>
            </template>

            <template #cell(report_review)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-group class="form-check form-check-inline">
                        <b-form-checkbox v-model="item.report_review" :value="1"/>
                    </b-form-group>
                </template>
                <template v-else>
                    <b-form-checkbox v-model="item.report_review" disabled="disabled" :value="1"/>
                </template>
            </template>

            <template #cell(observations)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-textarea v-model="item.observations" autocomplete="off"/>
                </template>
                <template v-else>
                    {{ item.observations }}
                </template>
            </template>

            <template #cell(provider_id)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.provider_id"
                        class="pt-0 width-300" label="provider" name="provider"
                        :reduce="(option) => option.id"
                        :options="providers"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    {{
                        providers.find(element => element.id == item.provider_id) ? providers.find(element => element.id == item.provider_id).provider : ''
                    }}
                </template>
            </template>



            <template #cell(document_type_id)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.document_type_id"
                        class="pt-0 width-300" label="type" name="type"
                        :reduce="(option) => option.id"
                        :options="documentsTypes"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    <b-badge v-if="isCorrective(item)" variant="secondary">
                        {{ taskName(item.document_type_id) }}
                    </b-badge>
                    <template v-else>
                        {{ taskName(item.document_type_id) }}
                    </template>
                </template>
            </template>
            <template #cell(options)="data">
                <div class="d-flex align-items-center" @click.stop>
                    <feather-icon
                        v-if="deletePermission"
                        :id="`record-row-${data.item.id}-edit-icon`"
                        :icon="getButtonIcon(data.item)"
                        class="cursor-pointer mr-1"
                        :class="getButtonVariant(data.item)"
                        size="16"
                        @click="editRow(data.item)"
                    />

                    <feather-icon
                        v-if="data.item.id"
                        :id="`record-row-${data.item.id}-see-icon`"
                        icon="SearchIcon"
                        size="16"
                        variant="warning"
                        class="cursor-pointer mr-1 text-blue"
                        @click="seeDocumentsList(data.item.id,true)"
                    />
                    <feather-icon
                        v-if="deletePermission"
                        :id="`record-row-${data.item.id}-delete-icon`"
                        icon="TrashIcon"
                        size="16"
                        class="cursor-pointer mr-1 text-red"
                        @click="deleteRecord(data.item.id, data.index, data.item )"
                    />
                    <feather-icon
                        v-if="deletePermission"
                        :id="`record-row-${data.item.id}-see-log-icon`"
                        icon="ClockIcon"
                        size="16"
                        class="cursor-pointer text-success"
                        @click="seeLogsDocument(data.item.id, data.item.logs)"
                    />
                </div>
            </template>

        </b-table>

        <b-modal v-model="showModal" hide-footer title="Documentos" size="lg" @hidden="closeModal">
            <b-table
                ref="refUserListTable"
                :items="documentsRoute"
                responsive
                :fields="columnsDocuments"
                primary-key="id"
                show-empty
                sticky-header
                editable
                striped
                empty-text="No hay registros"
                class="table-bordered "
                :key-field="'index'"
            >
                <template #cell(options)="data">
                    <div class="d-flex align-items-center justify-content-center">
                        <a href="javascript:void(0)" @click.prevent="openDocument(data.item.path, data.item.name)">
                            <feather-icon
                                v-if="!can('gei_delete_document_contract_client_ee')"
                                :id="`record-row-${data.item.id}-see-icon`"
                                icon="EyeIcon"
                                size="16"
                                variant="warning"
                                class="cursor-pointer mr-1 text-blue"
                                @click="seeDocument(currentDocumentId, data.item.path)"
                            />
                        </a>
                        <a href="javascript:void(0)" @click.prevent="downloadDocument(data.item.path, data.item.name)">
                            <feather-icon
                                v-if="!can('gei_delete_document_contract_client_ee')"
                                :id="`record-row-${data.item.id}-download-icon`"
                                icon="DownloadIcon"
                                size="16"
                                class="cursor-pointer mr-1 text-blue"
                            />
                        </a>
                        <feather-icon
                            v-if="deletePermission"
                            :id="`record-row-${data.item.id}-delete-icon`"
                            icon="TrashIcon"
                            size="16"
                            class="cursor-pointer text-red"
                            @click="deleteDocument(currentDocumentId, data.item.path)"
                        />
                    </div>
                </template>
            </b-table>
            <template>
                <div v-if="currentDocumentId>0">
                    <b-overlay
                        variant="white"
                        :show="showLoading"
                        spinner-variant="primary"
                        blur="0"
                        opacity=".75"
                        rounded="sm"
                    >
                        <vue-dropzone
                            id="dropzone"
                            ref="dropzone"
                            :options="dropzoneOptions"
                            :use-custom-slot="true"
                            @vdropzone-complete="complete">
                            <div class="dropzone-custom-content">
                                <h3 class="dropzone-custom-title">Arrastrar y soltar para subir archivo</h3>
                                <div class="subtitle">...o hacer clic para seleccionar un archivo de tu ordenador
                                </div>
                            </div>
                        </vue-dropzone>
                    </b-overlay>
                </div>
            </template>

            <b-button class="mt-3" variant="outline-danger" block @click="closeModal()">Cerrar</b-button>
        </b-modal>

      <log-modal
          v-model="showLogsModal"
          :show-logs-modal="showLogsModal"
          :logs="logsData"
          :per-page="logsPerPage"
      />
    </div>
</template>

<script>
import {BTable,BFormRadio, BFormInput, BModal, BButton, BOverlay, BFormTextarea, BFormCheckbox, BFormGroup, BFormSelect, BRow, BCol, BCollapse, BCard, BBadge} from 'bootstrap-vue'
import {baseUrl} from "@/constants/app"
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'
import authService from "@/services/auth/authService"
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import flatPickr from "vue-flatpickr-component"
import VueDropzone from "vue2-dropzone"
import helper from "@/resources/helpers/helpers"
import Swal from "sweetalert2"
import vSelect from "vue-select"
import {mapState} from "vuex"
import {mapFields} from "vuex-map-fields"
import {createPopper} from '@popperjs/core'

import {maintenancePeriods} from "@/constants/childrenDocuments"
import logModal from "@/views/gei/documents_log/logModal.vue"

export default {
    components: {
        logModal,
        BTable,
        BFormRadio,
        BFormInput,
        BModal,
        BButton,
        BOverlay,
        flatPickr,
        BFormTextarea,
        BFormCheckbox,
        BFormGroup,
        BFormSelect,
        BRow,
        BCol,
        BCollapse,
        BCard,
        BBadge,
        vSelect,
        VueDropzone: VueDropzone,
    },
    props: {
        documentsStateData: {
            type: Array,
            required: true
        },
        documentsColumns: {
            type: Array,
            required: true
        },
        documentsRoute: {
            type: Array,
            required: true
        },
        context: {
            type: String,
            required: true
        },
        createPermission: {
            type: Boolean,
        },
        deletePermission: {
            type: Boolean,
        }
    },

    data() {
        return {
            baseUrl,
            currentDocumentId: null,
            selectedRecords: [],
            selectedRow: null,
            placement: 'top',

            showLogsModal: false,
            logsData: [],
            logsPerPage: 5,
            currentPage: 1,

            showModal: false,
            SpanishLocale,
            edit: false,
            showLoading: false,
            urlDocs: null,
            editedRow: null,
            columnsDocuments: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'name', label: 'Archivo', sortable: false},
            ],
            dropzoneOptions: {},

            maintenancePeriods,

            showFilters: false,
            sortBy: '',
            sortDesc: false,
            filters: {
                periodicity: null,
                document_type_id: null,
                expected_from: null,
                expected_to: null,
                effective_from: null,
                effective_to: null,
            },
            dateFilterConfig: {
                dateFormat: 'd-m-Y',
                locale: SpanishLocale,
                allowInput: true,
                altInput: true,
                altFormat: 'd-m-Y',
            },
        }
    },
    computed: {
        ...mapState('providers', []),
        ...mapState('childrenInstallationDocuments', []),
        ...mapFields({
            providers: 'providers.providers',
            documentsTypes: 'documentsTypes.document_types',
            document_maintenance_active: 'childrenInstallationDocuments.document_maintenance_active',
        }),
        totalPages() {
          return Math.ceil(this.logsData.length / this.logsPerPage)
        },
        paginatedLogs() {
          const start = (this.currentPage - 1) * this.logsPerPage
          const end = start + this.logsPerPage
          return this.logsData.slice(start, end)
        },
        hasActiveFilters() {
            const f = this.filters
            return !!(f.periodicity || f.document_type_id || f.expected_from || f.expected_to || f.effective_from || f.effective_to)
        },
        activeFilterCount() {
            const f = this.filters
            return ['periodicity', 'document_type_id', 'expected_from', 'expected_to', 'effective_from', 'effective_to']
                .filter(k => f[k]).length
        },
        periodicityFilterOptions() {
            return [
                {value: null, text: 'Todas'},
                ...this.maintenancePeriods.map(p => ({value: p.value, text: p.name})),
            ]
        },
        taskFilterOptions() {
            const types = Array.isArray(this.documentsTypes) ? this.documentsTypes : []
            return [
                {value: null, text: 'Todas'},
                ...types.map(t => ({value: t.id, text: t.type})),
            ]
        },
        displayedItems() {
            let items = Array.isArray(this.documentsStateData) ? this.documentsStateData.slice() : []
            const f = this.filters

            if (this.hasActiveFilters) {
                items = items.filter(item => {
                    // Las filas nuevas o en edición siempre se muestran
                    if (!item.id || this.isRowEditable(item)) return true

                    if (f.periodicity && item.periodicity !== f.periodicity) return false
                    if (f.document_type_id && item.document_type_id !== f.document_type_id) return false

                    const exp = this.parseDmy(item.expected_date)
                    if (f.expected_from && (exp === null || exp < this.parseDmy(f.expected_from))) return false
                    if (f.expected_to && (exp === null || exp > this.parseDmy(f.expected_to))) return false

                    const eff = this.parseDmy(item.effective_date)
                    if (f.effective_from && (eff === null || eff < this.parseDmy(f.effective_from))) return false
                    if (f.effective_to && (eff === null || eff > this.parseDmy(f.effective_to))) return false

                    return true
                })
            }

            // Ordenación manual (no-local-sorting). Se congela mientras se edita una fila para evitar saltos.
            if (this.sortBy && !this.editedRow) {
                const key = this.sortBy
                const dateKey = key === 'expected_date' || key === 'effective_date'
                items.sort((a, b) => {
                    let av, bv
                    if (dateKey) {
                        av = this.parseDmy(a[key])
                        bv = this.parseDmy(b[key])
                    } else if (key === 'periodicity') {
                        av = this.periodicityName(a.periodicity)
                        bv = this.periodicityName(b.periodicity)
                    } else { // document_type_id (Tarea)
                        av = this.taskName(a.document_type_id)
                        bv = this.taskName(b.document_type_id)
                    }

                    const aEmpty = av === null || av === undefined || av === ''
                    const bEmpty = bv === null || bv === undefined || bv === ''
                    if (aEmpty && bEmpty) return 0
                    if (aEmpty) return 1   // los vacíos siempre al final
                    if (bEmpty) return -1

                    const cmp = dateKey ? (av - bv) : av.localeCompare(bv, 'es', {sensitivity: 'base'})
                    return this.sortDesc ? -cmp : cmp
                })
            }

            return items
        },
    },
    mounted() {
        this.getAllMaintenanceTaskTypes()
        this.$root.$refs.tabMaintenanceForm = this
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        parseDmy(value) {
            if (!value || typeof value !== 'string') return null
            const parts = value.split('-')
            if (parts.length !== 3) return null
            const n = parseInt(parts[2], 10) * 10000 + parseInt(parts[1], 10) * 100 + parseInt(parts[0], 10)
            return isNaN(n) ? null : n
        },
        periodicityName(value) {
            const p = this.maintenancePeriods.find(el => el.value == value)
            return p ? p.name : ''
        },
        taskName(id) {
            const t = Array.isArray(this.documentsTypes) ? this.documentsTypes.find(el => el.id == id) : null
            return t ? (t.type || '') : ''
        },
        isCorrective(item) {
            return /correctiv/i.test(this.taskName(item.document_type_id))
        },
        clearFilters() {
            this.filters.periodicity = null
            this.filters.document_type_id = null
            this.filters.expected_from = null
            this.filters.expected_to = null
            this.filters.effective_from = null
            this.filters.effective_to = null
        },
        withPopper(dropdownList, component, {width}) {
            dropdownList.style.width = width
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: this.placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({state}) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top'
                            )
                        },
                    },
                ],
            })

            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy()
        },
        isRowEditable(item) {
            return item === this.editedRow || item === this.documentsStateData.editedRow
        },
        editRow(item) {
            if (this.isRowEditable(item)) {
                this.editedRow = null
                this.updateRecord(item)

            } else {
                this.editedRow = item
            }
        },
        getButtonVariant(item) {
            return this.isRowEditable(item) ? 'text-green' : 'info'
        },
        getButtonIcon(item) {
            return this.isRowEditable(item) ? 'CheckIcon' : 'EditIcon'
        },
        getButtonText(item) {
            return this.isRowEditable(item) ? 'Guardar' : 'Editar'
        },
        closeModal() {
            this.showModal = false
            this.$root.$refs.childrenInstallationForm.getChildInstallation()
        },
        seeDocumentsList(id, logBool) {
            this.showLogsModal = false
            this.currentDocumentId = id
            this.updateDropzoneOptions()
            if (logBool) {
              this.setDocumentActionLog(id, 'seeList', 'Ha visto el listado de documentos')
            }
            this.$store.dispatch('childrenInstallationDocuments/getDocumentsList', {id: id, context: this.context})
            .then(response => {
                this.showLoading = false
                this.showModal = true
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        updateDropzoneOptions() {
            this.dropzoneOptions = {
                url: baseUrl + 'api/gei/children-installation/documents/' + this.context + '/upload-documents/' + this.currentDocumentId,
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                autoProcessQueue: true,
                addRemoveLinks: true,
                headers: {"Authorization": 'Bearer ' + authService.accessToken()},
            }
        },
        complete: function (file) {
            this.showLoading = true
            this.seeDocumentsList(this.currentDocumentId,false)
            let infoLog = 'Ha subido el documento ' + file.name
            this.setDocumentActionLog(this.currentDocumentId, 'upload', infoLog)
            setTimeout(() => {
                this.$refs.dropzone.removeAllFiles()
            }, 2000)
        },
        updateRecord(item) {
            item.context = this.context

            if (item.id) {
                this.$store.dispatch('childrenInstallationDocuments/updateRecordGeneralData', item)
                .then(() => {
                    this.showLoading = false
                    this.$root.$refs.childrenInstallationForm.getChildInstallation()

                    helper.showToast('Registro actualizado correctamente!', 'CheckIcon', 'success')
                })
                .catch(error => {
                    this.showLoading = false
                    helper.showToast('Error en editar al actualizar registro', 'AlertOctagonIcon', 'danger')
                })
            } else {
                this.$store.dispatch('childrenInstallationDocuments/createRecordGeneralData', item)
                .then(() => {
                    this.showLoading = false

                    this.$root.$refs.childrenInstallationForm.getChildInstallation()
                    helper.showToast('Registro creado correctamente!', 'CheckIcon', 'success')
                })
                .catch(error => {
                    this.showLoading = false
                    helper.showToast('Error en editar al crear registro', 'AlertOctagonIcon', 'danger')
                })
            }
        },
        deleteRecord(id, index, item) {
            if (id) {
                Swal.fire({
                    title: "Estás seguro que quieres borrar el registro?",
                    text: "Una vez borrado no se podrá recuperar!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "¡Sí, borralo!",
                    cancelButtonText: "Cancelar",
                }).then(result => {
                    if (result.value) {
                        this.showLoading = true
                        this.$store.dispatch('childrenInstallationDocuments/deleteRecord', {
                            id: id,
                            context: this.context
                        })
                        .then(response => {
                            this.showLoading = false
                            helper.showToast('Registro eliminado correctamente!', 'CheckIcon', 'success')
                            this.$root.$refs.childrenInstallationForm.getChildInstallation()
                        })
                        .catch(error => {
                            this.showLoading = false
                            console.log(error)
                        })
                    }
                })
            } else {
                // Fila nueva sin guardar: borrar por referencia del objeto, ya que con
                // filtros/orden activos el índice mostrado no coincide con el del array.
                const realIndex = item ? this.documentsStateData.indexOf(item) : index
                if (realIndex > -1) {
                    this.documentsStateData.splice(realIndex, 1)
                }
            }
        },
        deleteDocument(recordId, path) {
            if (recordId) {
                const fileName = path.split('/').pop()
                const pathParts = path.split('/')
                const folderNumber = pathParts[pathParts.length - 2]

                Swal.fire({
                    title: "Estás seguro que quieres borrar el archivo?",
                    text: "Una vez borrado no se podrá recuperar!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "¡Sí, borralo!",
                    cancelButtonText: "Cancelar",
                }).then(result => {
                    if (result.value) {
                        this.showLoading = true
                        this.$store.dispatch('childrenInstallationDocuments/deleteDocument', {
                            id: recordId,
                            path: path,
                            context: this.context
                        })
                        .then(response => {
                          this.showLoading = false
                          let infoLog = 'Ha eliminado el documento ' + fileName
                          this.setDocumentActionLog(recordId, 'delete', infoLog)
                          this.$root.$refs.childrenInstallationForm.getChildInstallation()
                          helper.showToast('Registro eliminado correctamente!', 'CheckIcon', 'success')
                          this.seeDocumentsList(this.currentDocumentId,false)
                        })
                        .catch(error => {
                            this.showLoading = false
                            console.log(error)
                        })
                    }
                })
            }
        },
        getAllMaintenanceTaskTypes() {
            this.showLoading = true

            this.$store.dispatch('maintenanceTaskTypes/getAllMaintenanceTaskTypes')
            .then(response => {
                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        setActiveMaintenance(item) {
            this.showLoading = true
            console.log(item)
            this.$store.dispatch('childrenInstallationDocuments/setActiveMaintenance', {data: item.id})

            const newRow = {
              effective_date: null,
              made_by: null,
              observations: null,
              route: this.$store.state.childrenInstallation.child_installation.master_installation.installation_code +
                  "/" + this.$store.state.childrenInstallation.child_installation.gei_code +
                  "/MANTENIMIENTOS/INSPECCIONES",
              maintenance_id: this.document_maintenance_active
            }

            if (Array.isArray(item.inspections)) {
                const existingElement = item.inspections.find(inspection => 
                    inspection.effective_date === newRow.effective_date &&
                    inspection.made_by === newRow.made_by &&
                    inspection.observations === newRow.observations &&
                    inspection.route === newRow.route && 
                    inspection.maintenance_id === newRow.maintenance_id
                )
                
                if (!existingElement) {
                    item.inspections.push(newRow)
                }
                this.setInspections(item.inspections)

            } else {
                item.inspections = [newRow]
                this.$store.state.childrenInstallationDocuments.documents_maintenance_inspection.push(newRow)
            }

            if(item.insitu !== 'undefined' && item.insitu !== null) {
                this.setInSitu(item.insitu)
            } else {
                const newRow = [{
                    effective_date: null,
                    made_by: null,
                    observations: null,
                    route: this.$store.state.childrenInstallation.child_installation.master_installation.installation_code +"/"+ this.$store.state.childrenInstallation.child_installation.gei_code + "/MANTENIMIENTOS/ACAEInSitu",
                    maintenance_id: this.document_maintenance_active
                }]

                this.$store.state.childrenInstallationDocuments.documents_maintenance_insitu = (newRow)
            }
            if(item.atex !== 'undefined' && item.atex !== null) {
                this.setAtex(item.atex)
            }  else {
                const newRow = [{
                    effective_date: null,
                    made_by: null,
                    observations: null,
                    route: this.$store.state.childrenInstallation.child_installation.master_installation.installation_code +"/"+ this.$store.state.childrenInstallation.child_installation.gei_code + "/MANTENIMIENTOS/ATEX",
                    maintenance_id: this.document_maintenance_active
                }]

                this.$store.state.childrenInstallationDocuments.documents_maintenance_atex = (newRow)
            }
            if(item.invigilando !== 'undefined' && item.invigilando !== null) {
                this.setInvigilando(item.invigilando)
            } else {
                const newRow = [{
                    effective_date: null,
                    made_by: null,
                    observations: null,
                    route: this.$store.state.childrenInstallation.child_installation.master_installation.installation_code +"/"+ this.$store.state.childrenInstallation.child_installation.gei_code + "/MANTENIMIENTOS/INVIGILANDO",
                    maintenance_id: this.document_maintenance_active
                }]

                this.$store.state.childrenInstallationDocuments.documents_maintenance_invigilando = (newRow)
            }
           
        },
        setInspections(inspections) {
            if (inspections) {
                this.$store.dispatch('childrenInstallationDocuments/setInspectionsByMaintenance', {data: inspections})
            }  
        },
        setAtex(atex) {
            if(atex){
                this.$store.dispatch('childrenInstallationDocuments/setAtexByMaintenance', {data: atex})
            }
        },
        setInSitu(insitu) {
            if(insitu){
                this.$store.dispatch('childrenInstallationDocuments/setInSituByMaintenance', {data: insitu})
            }
        },
        setInvigilando(invigilando) {
            if(invigilando){
                this.$store.dispatch('childrenInstallationDocuments/setInvigilandoByMaintenance', {data: invigilando})
            }
        },
        setDocumentActionLog(id, action, info) {
          this.$store.dispatch('logDocuments/setDocumentActionLog', {
            id: id,
            model: this.context,
            action: action,
            info: info,
          })
        },
        seeDocument(recordId, path) {
          if (recordId) {
            const fileName = path.split('/').pop()
            const pathParts = path.split('/')
            const folderNumber = pathParts[pathParts.length - 2]

            let infoLog = 'Ha visto el documento ' + fileName
            this.setDocumentActionLog(recordId, 'see', infoLog)
          }
        },
        seeLogsDocument(id, logs) {
          this.showLogsModal = false
          this.logsData = logs.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          this.$nextTick(() => {
            this.showLogsModal = true
          })
        },
        closeLogsModal() {
          this.logsData = []
          this.currentPage = 1
          this.showLogsModal = false
          this.$emit("update:showLogsModal", false)
        },
        formatDateTime(datetime) {
          const date = new Date(datetime)
          const formattedDate = date.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })
          const formattedTime = date.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          })
          return `${formattedDate} ${formattedTime}`
        },
        previousPage() {
          if (this.currentPage > 1) {
            this.currentPage--
          }
        },
        nextPage() {
          if (this.currentPage < this.totalPages) {
            this.currentPage++
          }
        },
        onRecordSelected(items) {
          if (!this.editedRow) {
            this.selectedRecords = items
          }
        },
        deleteSelectedRecords() {
          Swal.fire({
            title: this.selectedRecords.length === 1 ? "¿Estás seguro que quieres borrar el registro seleccionado?" : "¿Estás seguro que quieres borrar los registros seleccionados?",
            text: this.selectedRecords.length === 1 ? "¡Una vez borrado no se podrá recuperar!" : "¡Una vez borrados no se podrán recuperar!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "¡Sí, borralo!",
            cancelButtonText: "Cancelar",
          }).then(result => {
            if (result.value) {
              this.showLoading = true

              const deletePromises = this.selectedRecords.map(record => {
                return this.$store.dispatch('childrenInstallationDocuments/deleteRecord', {
                  id: record.id,
                  context: this.context,
                })
              })

              Promise.all(deletePromises)
                  .then(() => {
                    helper.showToast(
                        this.selectedRecords.length === 1
                            ? "¡Registro eliminado correctamente!"
                            : "¡Registros eliminados correctamente!",
                        'CheckIcon',
                        'success'
                    )

                    this.$root.$refs.childrenInstallationForm.getChildInstallation()

                    this.selectedRecords = []
                  })
                  .catch(error => {
                    console.log(error)
                  })
                  .finally(() => {
                    this.showLoading = false
                  })
            } else {
              this.selectedRecords = []
            }
          })
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

[dir] .modal .modal-header .close {
    box-shadow: none;
    transform: unset;
    background: none;
}

.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

</style>

<style lang="scss">
/* Cabeceras en una sola línea y centradas verticalmente: el icono de orden queda
   inline junto al texto y la fila de cabecera no queda alta (los datos siguen
   ajustándose; nowrap solo afecta a los th, no al contenido de las celdas). */
.maintenance-tasks-table thead th {
    white-space: nowrap;
    vertical-align: middle;
}
</style>